module.exports = __webpack_public_path__ + "img/Back Door Right Salone.83849416.png";